import React from 'react'
import { Helmet } from 'react-helmet'
import Products from '../../sections/product/Products'

function Product() {

  return (
    <>
      <Helmet>
          <title>Produit</title>
      </Helmet>

      <Products />
    </>
  )
}

export default Product